import type {IOptionModel} from "@/models/option";
import type {PaginatedSelectListResponse} from "@/models/pagination";

export const getFromOptions = (options: IOptionModel<number | string>[], value: any, fallbackValue: any = undefined): string | undefined => {
    if (!options) return "";
    let option = options.find(x => x.value == value)?.label;

    if(!option && fallbackValue) {
        return getFromOptions(options, fallbackValue);
    }

    return option;
}

export const convertToOptions = <T extends PaginatedSelectListResponse>(items: T[]): IOptionModel<number>[] => {
    return items.map(item => ({
        value: item.id,
        label: item.name,
    }))
}

export const translateOptions = (translate: any, options: IOptionModel<number | string>[]) => {
    return options.map(option => ({...option, label: translate(option.label)}));
}
